export const CURRENCY = { symbol: "£" };

export function money(v, symbol) {
  const s = symbol || CURRENCY.symbol;
  const n = Number(v || 0);
  return `${s}${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "—";
  }
}

export function fmtDateInput(d) {
  if (!d) return "";
  try { return new Date(d).toISOString().slice(0, 10); } catch { return ""; }
}

export const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-600 border-slate-200",
  sent: "bg-blue-50 text-blue-700 border-blue-200",
  accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  partial: "bg-amber-50 text-amber-700 border-amber-200",
  overdue: "bg-red-50 text-red-700 border-red-200",
  declined: "bg-red-50 text-red-700 border-red-200",
  expired: "bg-slate-100 text-slate-500 border-slate-200",
  scheduled: "bg-blue-50 text-blue-700 border-blue-200",
  in_progress: "bg-amber-50 text-amber-700 border-amber-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  submitted: "bg-blue-50 text-blue-700 border-blue-200",
  pending_approval: "bg-amber-50 text-amber-700 border-amber-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
};

export function statusLabel(s) {
  return String(s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export const PLAN_META = {
  free: { name: "Free", rank: 0 },
  basic: { name: "Basic", rank: 1 },
  full: { name: "Full", rank: 2 },
};

export const FEATURE_MIN_PLAN = {
  customers: "free", products: "free", quotes: "free", invoices: "free", leads: "free", services: "free",
  send_docs: "basic", jobs: "basic", planner: "basic", expenses: "basic", reports: "basic", alfie: "basic", website: "basic",
  employees: "full", timekeeping: "full", materials: "full",
};

export function planAllows(plan, feature) {
  const need = PLAN_META[FEATURE_MIN_PLAN[feature] || "free"].rank;
  return PLAN_META[plan || "free"].rank >= need;
}
